import {makeSignUpSendToken} from 'main/factories/usecases';
import {SignUpSendTokenParams} from './types.js';

export async function signUpSendToken({signal, ...tokenParams}: SignUpSendTokenParams) {
	const response = await makeSignUpSendToken().signUpSendToken({signal, ...tokenParams});

	return response;
}
